import { LayoutProvider } from "@/components/common/layout/layout-provider";
import { PageHeader } from "@/components/common/page-header";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ClientsAppointmentsTabContent } from "./clients-appointments-tab-content";
import { ClientsTabContent } from "./clients-tab-content";

const tabTriggerClass =
  "data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none data-[state=active]:font-semibold rounded-none pb-0 mb-[-2px] text-base";

export function ClientsPage() {
  return (
    <div>
      <PageHeader title="Manage Clients" />
      <LayoutProvider>
        <Tabs defaultValue="appointments">
          <TabsList className="bg-neutral-50 border-b-2 border-border rounded-none w-full p-0 h-auto justify-start">
            <TabsTrigger className={tabTriggerClass} value="appointments">
              Appointments
            </TabsTrigger>
            <TabsTrigger className={tabTriggerClass} value="details">
              Details
            </TabsTrigger>
          </TabsList>
          <TabsContent value="appointments">
            <ClientsAppointmentsTabContent />
          </TabsContent>
          <TabsContent value="details">
            <ClientsTabContent />
          </TabsContent>
        </Tabs>
      </LayoutProvider>
    </div>
  );
}
